module.exports = __webpack_public_path__ + "img/package.6a08ef86.png";